import { render, staticRenderFns } from "./TicketGrabs.vue?vue&type=template&id=0a97f0a0&scoped=true&"
import script from "./TicketGrabs.vue?vue&type=script&lang=ts&"
export * from "./TicketGrabs.vue?vue&type=script&lang=ts&"
import style0 from "./TicketGrabs.vue?vue&type=style&index=0&id=0a97f0a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a97f0a0",
  null
  
)

export default component.exports